import { SingleChoiceProps } from "./QuizTypes";
import { SingleChoiceSelectedSVG, SingleChoiceSVG } from "./SVG";
import './Quiz.css';
const SingleChoice: React.FC<SingleChoiceProps> = ({
    value,
    answer,
    handleRadioChange,
    styleConfig,
    themeConfig,
    newId,
    isV1Api,
    formDataSecondary,
    questThemeData,
    optionsHeader,
    optionRankFormat,
    unselectedSvg,
    selectedSvg,
    optionCheckboxes,
    singleTranslatedTitle
}) => {
    const translatedCriteria = formDataSecondary.find(
        (criteria: any) => criteria.criteriaId === value.criteriaId
    );

    const optionRank = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];

    return (
        <>
            {optionsHeader == true && <p className="quiz-options-header">{singleTranslatedTitle}</p>}
            <div className="quiz-header-ques-options">
                {value?.options.map((option: string, index: number) => {
                    const SelectedBorder = {
                        border: `2px solid ${questThemeData?.accentColor || '#9035FF'}`,
                    };
                    const SelectedOptionColor = {
                        color: styleConfig?.OptionsSelectedColor?.color || '#9035FF',
                        fontFamily: themeConfig?.fontFamily,
                    };

                    return (
                        <div
                            key={index}
                            onClick={() => handleRadioChange(option, value[newId])}
                            className={`${answer[value[newId]]?.includes(option)
                                ? "selected-option"
                                : "not-selected"
                                }`}
                            style={
                                answer[value[newId]]?.includes(option)
                                    ? SelectedBorder
                                    : {
                                        borderColor: themeConfig?.borderColor,
                                    }
                            }
                        >
                            {optionRankFormat === 'alphabetic' && <span className="option-rank">{optionRank[index]}</span>}
                            {optionRankFormat === 'number' && <span className="option-rank">{index + 1}</span>}
                            <p
                                style={
                                    answer[value[newId]]?.includes(option)
                                        ? SelectedOptionColor
                                        : {
                                            color: themeConfig?.primaryColor,
                                            fontFamily: themeConfig?.fontFamily,
                                        }
                                }
                            >
                                {isV1Api ? translatedCriteria?.options[index] : option}
                            </p>
                            {optionCheckboxes === true ? answer[value[newId]]?.includes(option) ? selectedSvg || SingleChoiceSelectedSVG(styleConfig?.OptionsSelectedColor?.color) : unselectedSvg || SingleChoiceSVG(themeConfig?.borderColor) : null}
                        </div>
                    );
                })}
            </div>
        </>
    );
};

export default SingleChoice;